// prettier-ignore
export const contractADMIN = "0x12F0215Ee1fd10a3a8F19224265AAC5472961639";
export const NETWORK = "56";
export const NETWORKNAME = "BNB Smart Chain";
// export const PROVIDER = "https://rpc.ankr.com/bsc";  //5sec
export const PROVIDER = "https://bsc-dataseed.binance.org/"; //
